import React, { useState, useEffect } from 'react'
import { ATSwitchProps } from './FormComponentProps'

const defaultSegment = [
  { label: 'yes', value: true },
  { label: 'no', value: false },
]

const ATSwitch: React.FC<ATSwitchProps> = ({
  segments = defaultSegment,
  callback,
  activeIndex = 0,
  disabled = false,
  classname,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0) //true
  const toggleSwitch = (value: string | boolean, index: number) => {
    setCurrentIndex(index)
    callback(value, index)
  }

  useEffect(() => {
    setCurrentIndex(activeIndex)
  }, [activeIndex])

  return (
    <>
      <div className={`${!classname ? 'switch-container' : classname}`}>
        <div
          className={`${disabled ? 'switch-block-disabled' : 'switch-block'}`}
        >
          {segments?.map((item, i) => (
            <div key={item.value} className="switch-btn-block">
              <button
                type="button"
                className={`switch-btn ${
                  i === currentIndex ? 'active' : 'inactive'
                }`}
                onClick={() => toggleSwitch(item.value, i)}
                disabled={disabled}
              >
                <span className="switch-label">{item.label}</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ATSwitch
